import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://gnjqxetwmfzgkbivtzdm.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImduanF4ZXR3bWZ6Z2tiaXZ0emRtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY5NDU4ODcsImV4cCI6MjA2MjUyMTg4N30.qxkf9ARQ2uC9ncW0kGLTNQNwuD4ucl8GOQYL_7DgHZc';
if (!supabaseUrl || !supabaseKey) {
  throw new Error('Missing Supabase URL or anon key; check your env vars')
}

export const supabase = createClient(supabaseUrl, supabaseKey)